import { Link } from 'react-router-dom'
import { Explicacao } from '../../components/Explicacao'
import { TEXTOS } from '../../lib/glossario'
import type { NumerosDoMes } from '../../types/repositorios'

/**
 * O aviso de que a equipe interna ficou fora da conta.
 *
 * Os números do mês excluem quem está no Diário de Bordo (decisão do dono, 07/09/2026). Sem este
 * aviso, um fiscal que conhece a pessoa e sabe que ela fez commit leria a tela como coleta
 * incompleta. O link leva ao recorte só da equipe interna, para quem quiser ver o que saiu.
 *
 * @param props os números e o mês, para o link
 * @returns o aviso, ou nada quando ninguém da equipe interna fez commit
 */
export function AvisoDaEquipeInterna({ numeros, competencia }: { numeros: NumerosDoMes; competencia: string }) {
  const t = TEXTOS.repositorios.equipeInterna
  if (numeros.equipeInternaCommits <= 0) {
    return null
  }
  return (
    <p
      role="note"
      className="flex flex-wrap items-center gap-x-2 gap-y-1 rounded-md border border-slate-200 bg-slate-50 px-4 py-2 text-sm text-slate-700"
    >
      <span className="inline-flex items-center gap-1">
        {t.aviso(numeros.equipeInternaCommits, numeros.equipeInternaPessoas)}
        <Explicacao termo="equipeInterna" />
      </span>
      <Link
        to={`/repositorios?competencia=${competencia}&aba=commits&equipeInterna=true`}
        className="text-xs font-medium text-niteroi-700 underline underline-offset-2 hover:text-niteroi-900"
      >
        {t.verCommits}
      </Link>
    </p>
  )
}
